import {request} from "@/utils/request";
/**
 * 开始任务
 */
export function _startTask(data) {
    return request({
        url: "/similar_api/similar/word_check_to_html",
        method: "POST",
        data,
    });
}

export function startTask(data){
    return request({
        url: "/bswjjc/word/similar/word_check_to_html",
        method: "POST",
        data,
    });
}

/**
 * 查询任务进度
 */
export function _getStatus(data){
    return request({
        url: "/similar_api/similar/process_status",
        method: "get",
        params:data
    });
}
/**
 * 查询任务进度
 */
export function getStatus(data){
    return request({
        url: "/bswjjc/word/similar/process_status",
        method: "get",
        params:data
    });
}

/**
 * 获取目录
 */
export function _getCatelogue(data){
    return request({
        url:"/similar_api/similar/get_catelogue",
        method:"get",
        params:data
    })
}
/**
 * 获取目录
 */
export function getCatelogue(data){
    return request({
        url:"/bswjjc/word/similar/get_catelogue",
        method:"get",
        params:data
    })
}

/**
 * 任务评估
 */
export function _getEvaluation(data){
    return request({
        url: "/similar_api/similar/get_evaluation",
        method: "get",
        params:data
    });
}

/**
 * 任务评估
 */
export function getEvaluation(data){
    return request({
        url: "/bswjjc/word/similar/get_evaluation",
        method: "get",
        params:data
    });
}

/**
 * 获取基本结构
 */
export function _getBaseData(data){
    return request({
        url: "/similar_api/similar/get_base_info",
        method: "get",
        params:data
    })
}

/**
 * 获取基本结构
 */
export function getBaseData(data){
    return request({
        url: "/bswjjc/word/similar/get_base_info",
        method: "get",
        params:data
    })
}

/**
 * 查询结果
 */

export function _getResult(data){
    return request({
        url: "/similar_api/similar/pdf_get_result",
        method: "get",
        params:data
    });
}
export function getResult(data){
    return request({
        url: "/bswjjc/similar/getResultHead",
        method: "get",
        params:data
    });
}

/**
 * 查询图片文件夹
 */
export function _getImgInfo(data){
    return  request({
        url: "/similar_api/similar/img_info",
        method: "post",
        data:data
    });
}
export function getImgInfo(data){
    return  request({
        url: "/bswjjc/word/similar/img_info",
        method: "post",
        data:data
    });
}
/**
 * 获取异常项结果
 */

export function _getAbnormal(data){
    return request({
        url: "/similar_api/similar/get_abnormal",
        method: "get",
        params:data
    });
}

/**
 * 获取异常项结果
 */

export function getAbnormal(data){
    return request({
        url: "/bswjjc/word/similar/get_abnormal",
        method: "get",
        params:data
    });
}

/**
 * 获取电话号异常项
 */

export function getPhoneAbnormal(data){
    return request({
        url: "/bswjjc/word/similar/get_phone_abnormal",
        method: "get",
        params:data
    });
}


/**
 * 获取文件列表
 */
export function  _getFileList(data){
    return request({
        url: "/similar_api/similar/get_word_name",
        method: "get",
        params:data
    });
}

export function  getFileList(data){
    return request({
        url: "/bswjjc/word/similar/get_word_name",
        method: "get",
        params:data
    });
}

/**
 * 获取html文件
 */

export function  _getFile(data){
    return request({
        url: "/similar_api/similar/get_file",
        method: "post",
        data:data
    });
}
export function  getFile(data){
    return request({
        url: "/bswjjc/word/similar/get_file",
        method: "post",
        data:data
    });
}
/**
 * 导出
 */

export function exportFile(data){
    return request({
        url: "/similar_api/similar/get_sim_excel",
        method: "get",
        params:data
    });
}

/**
 * 获取用户服务次数
 */
export function _getServiceNum(data){
    return request({
        url: "/similar_api/similar/get_user_info",
        method: "get",
        params:data
    });
}
export function getServiceNum(data){
    return request({
        url: "/bswjjc/similar/get_user_info",
        method: "get",
        params:data
    });
}

/**
 * 查询历史记录
 */
export function _getHistory(data){
    return request({
        url: "/similar_api/similar/check_history",
        method: "get",
        params:data
    });
}

export function getHistory(data){
    return request({
        url: "/bswjjc/similar/getHistory",
        method: "post",
        data:data
    });
}




/**
 * 查历史记录详情
 */
export function getDetail(data){
    return request({
        url: "/similar_api/similar/check_history_detail",
        method: "get",
        params:data
    });
}

/**
 * 删除历史记录
 */
export function delHistory(data){
    return request({
        url: "/similar_api/similar/del_history",
        method: "post",
        data:data
    });
}

/**
 * 取消任务
 */
export function _revokeTask(data){
    return request({
        url: "/similar_api/similar/revoke_task",
        method: "get",
        params:data
    });
}
/**
 * 取消任务
 */
export function revokeTask(data){
    return request({
        url: "/bswjjc/word/similar/revoke_task",
        method: "get",
        params:data
    });
}
